import moment from "moment/moment";

export default function (dailyRegistrationData, registrationCountField) {
  const dailyRegistration = dailyRegistrationData || [];
  const labels = [];
  const datasets = [
    {
      label: "Partner Count",
      fill: true,
      borderColor: "var(--primary)",
      backgroundColor: "var(--primary)",
      pointBorderColor: "var(--primary)",
      borderWidth: 3,
      data: [],
    },
  ];
  if (dailyRegistration && dailyRegistration.length > 0) {
    let lastKnownTime = "01-Jan-1900";
    const minCol = 12;
    dailyRegistration.map((x) => {
      labels.push(`${x.date}`);
      lastKnownTime = `${x.date}`;
      datasets[0].data.push(+parseFloat(x[registrationCountField]).toFixed(2));
    });
    if (datasets[0].data.length < minCol) {
      lastKnownTime = moment(`${labels}`, "YYYY-MM-DD");
      Array(minCol - datasets[0].data.length)
        .fill(0)
        .map((_, i) => {
          labels.unshift(lastKnownTime.add(-1, "days").format("YYYY-MM-DD"));
          datasets[0].data.unshift(0.0);
        });
    }
  }
  return {
    labels,
    datasets,
  };
}
